import {
  PhoneIcon,
  HomeIcon,
  ShoppingBagIcon,
  ArchiveIcon,
  CogIcon,
  PlayIcon,
  LogoutIcon,
  UserAddIcon,
  FolderAddIcon,
  MailIcon,
  CreditCard,
  CreditCardIcon,
  UserIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/outline";
import { logout } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useSideNavState } from "../../../zust";

export const NavLinks = () => {
  const dispatch = useDispatch();
  const { sideNavState } = useSideNavState();

  const navLinks = [
    {
      name: "Dashboard",
      href: "/dashboard",
      Icon: HomeIcon,
      color: "from-primary-500 to-primary-600",
      bgColor: "bg-primary-500/10",
    },
    {
      name: "Invest",
      href: "/dashboard/proceed",
      Icon: PlayIcon,
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-500/10",
    },
    {
      name: "Deposit",
      href: "/dashboard/fund",
      Icon: FolderAddIcon,
      color: "from-primary-500 to-primary-600",
      bgColor: "bg-primary-500/10",
    },
    {
      name: "Withdraw",
      href: "/dashboard/withdraw",
      Icon: CreditCardIcon,
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-500/10",
    },
    {
      name: "Investment Plans",
      href: "/dashboard/plans",
      Icon: ShoppingBagIcon,
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-500/10",
    },
    {
      name: "Deposits History",
      href: "/dashboard/deposits",
      Icon: ArchiveIcon,
      color: "from-green-900 to-green-600",
      bgColor: "bg-green-500/10",
    },
    {
      name: "Withdrawals History",
      href: "/dashboard/withdrawals",
      Icon: ArchiveIcon,
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-500/10",
    },
    {
      name: "Account Settings",
      href: "/dashboard/account",
      Icon: CogIcon,
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-500/10",
    },
  ];

  return (
    <div className=" flex flex-col space-y-4 md:space-y-2 mb-6 w-[200px] mx-auto">
      {navLinks.map(({ name, Icon, href, color, bgColor }, index) => (
        <Link to={href} key={index} tabIndex={sideNavState ? 0 : -1}>
          <div className="group flex  px-3 py-3 rounded-xl cursor-pointer  hover:bg-slate-700/50 transition-all duration-200">
            <div
              className={` rounded-lg bg-gradient-to-br mr-3 group-hover:scale-110 transition-transform`}
            >
              <Icon className="h-5 w-5 text-white" />
            </div>

            <h1 className="text-sm font-medium font-body text-slate-200 group-hover:text-white transition-colors">
              {name}
            </h1>
          </div>
        </Link>
      ))}
    </div>
  );
};

export const AdminNavLinks = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { sideNavState } = useSideNavState();

  const navLinks = [
    {
      name: "Dashboard",
      href: "/admin/dashboard",
      Icon: HomeIcon,
    },
    {
      name: "Users",
      href: "/admin/users",
      Icon: UserIcon,
    },
    // {
    //   name: "Plans",
    //   href: "/admin/plans",
    //   Icon: ShoppingBagIcon,
    // },
    {
      name: "Payments",
      href: "/admin/payments",
      Icon: PlayIcon,
    },
    {
      name: "Currency",
      href: "/admin/currency",
      Icon: CurrencyDollarIcon,
    },
  ];

  const signOut = () => {
    dispatch(logout());
    history.push("/admin");
  };

  return (
    <div className="mt-16">
      {navLinks.map(({ name, Icon, href }, index) => (
        <Link to={href} key={index} tabIndex={sideNavState ? 0 : -1}>
          <div
            className="
          flex items-center px-3 py-4 
          cursor-pointer hover:bg-hover 
          "
          >
            <Icon className="h-6 mr-4 " />
            <h1 className=" text-md text-base  ">{name}</h1>
          </div>
        </Link>
      ))}
      <div
        className="
          flex items-center px-3 py-4 
          cursor-pointer hover:bg-hover 
          "
        onClick={() => signOut()}
        role="button"
        tabIndex={sideNavState ? 0 : -1}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            signOut();
          }
        }}
        aria-label="Log out"
      >
        <LogoutIcon className="h-6 mr-4 " />
        <h1 className="text-lg  ">Log out</h1>
      </div>
    </div>
  );
};
